import utils from './utilities'
import store from './store'
import request from './requests'


export var amountOfSelectedBooksPDF = null;
export var amountOfSelectedBooksXLSX = null;
export var deliveredBooksPDF = null;
export var deliveredBooksXLSX = null;
export var booksDistributionXLSX = null;
export var homeDeliveryXLSX = null;
export var homeDeliveryXLSX1 = null;
export var amountOfBooksDeliveredForAllDpPdf = null;
export var amountOfBooksDeliveredPerDpPdf = null;
export var amountOfBooksDeliveredForAllDpXlsx = null;
export var amountOfBooksDeliveredPerDpXlsx = null;
export var publisherBooksXlsx = null;
export var publisherSelectedBooksXlsx = null;
export var publisherLibraryOrdersDeliveredXlsx = null;
export var publisherLibraryOrdersDeliveredPdf = null;
export var publisherLibraryOrdersXlsx = null;
export var publisherLibraryOrdersPdf = null;
export var publisherBooksFromCourierDeliveredXlsx = null;
export var publisherBooksFromCourierDeliveredPdf = null;

export var startServiceAmountOfPDFobj = {};
export var startServiceAmountOfXLSXobj = {};
export var startServiceDeliveredBooksPDFobj = {};
export var startServiceDeliveredBooksXLSXobj = {};
export var startServiceBooksDistributionXLSXobj = {};
export var startServiceHomeDeliveryXLSXobj = {};
export var startServiceHomeDeliveryXLSX1obj = {};
export var startServiceAmountOfBooksDeliveredForAllDpPdfobj = {};
export var startServiceAmountOfBooksDeliveredPerDpPdfobj = {};
export var startServiceAmountOfBooksDeliveredForAllDpXlsxobj = {};
export var startServiceAmountOfBooksDeliveredPerDpXlsxobj = {};
export var startServicePublisherBooksXlsxobj = {};
export var startServicePublisherSelectedBooksXlsxobj = {};
export var startServicePublisherLibraryOrdersDeliveredXlsxObj ={};
export var startServicePublisherLibraryOrdersDeliveredPdfObj = {};
export var startServicePublisherLibraryOrdersXlsxObj = {};
export var startServicePublisherLibraryOrdersPdfObj = {};
export var startServicePublisherBooksFromCourierDeliveredXlsxobj = {};
export var startServicePublisherBooksFromCourierDeliveredPdfobj= {};

export var publisherStatementAndDeliveryStatsReportPolling = null;
export var publisherStatementAndDeliveryStatsReportRequestObj = {};


var Serv = {

    startServicePublisherLibraryOrdersPdf(dates, institution) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);
        if(institution === -1){
            institution = null;
        }
        if(publisherLibraryOrdersPdf == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit("setPublisherLibraryOrdersPdf", storeObj);
        publisherLibraryOrdersPdf = setInterval( () => {
            var obj = {
                type: "publisherLibraryOrders",
                requesterId: null,
                format: "pdf",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: institution,
                distributionPointId: null
            };
            startServicePublisherLibraryOrdersPdfObj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherLibraryOrdersPdfCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        }, 5000)
    },

    startServicePublisherLibraryOrdersPdfCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherLibraryOrdersPdf));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherLibraryOrdersPdf", storeObj);
                clearInterval(publisherLibraryOrdersPdf);
                publisherLibraryOrdersPdf = null;
                utils.downloadReport(startServicePublisherLibraryOrdersPdfObj);
            }
        }
        else {
            store.commit("setPublisherLibraryOrdersPdf", storeObj);
            clearInterval(publisherLibraryOrdersPdf);
            publisherLibraryOrdersPdf = null;
        }
    },

    startServicePublisherLibraryOrdersXlsx(dates, institution) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(institution === -1){
            institution = null;
        }
        if(publisherLibraryOrdersXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit("setPublisherLibraryOrdersXlsx", storeObj);
        publisherLibraryOrdersXlsx = setInterval( () => {
            var obj = {
                type: "publisherLibraryOrders",
                requesterId: null,
                format: "xlsx",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: institution,
                distributionPointId: null
            };
            startServicePublisherLibraryOrdersXlsxObj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherLibraryOrdersXlsxCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        }, 5000)
    },

    startServicePublisherLibraryOrdersXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherLibraryOrdersXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherLibraryOrdersXlsx", storeObj);
                clearInterval(publisherLibraryOrdersXlsx);
                publisherLibraryOrdersXlsx = null;
                utils.downloadReport(startServicePublisherLibraryOrdersXlsxObj);
            }
        }
        else {
            store.commit("setPublisherLibraryOrdersXlsx", storeObj);
            clearInterval(publisherLibraryOrdersXlsx);
            publisherLibraryOrdersXlsx = null;
        }
    },

    startServicePublisherLibraryOrdersDeliveredPdf(dates, institution) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(institution === -1){
            institution = null;
        }
        if(publisherLibraryOrdersDeliveredPdf == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit("setPublisherLibraryOrdersDeliveredPdf", storeObj);
        publisherLibraryOrdersDeliveredPdf = setInterval( () => {
            var obj = {
                type: "publisherLibraryOrdersDelivered",
                requesterId: null,
                format: "pdf",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: institution,
                distributionPointId: null
            };
            startServicePublisherLibraryOrdersDeliveredPdfObj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherLibraryOrdersDeliveredPdfCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        }, 5000)
    },

    startServicePublisherLibraryOrdersDeliveredPdfCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherLibraryOrdersDeliveredPdf));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherLibraryOrdersDeliveredPdf", storeObj);
                clearInterval(publisherLibraryOrdersDeliveredPdf);
                publisherLibraryOrdersDeliveredPdf = null;
                utils.downloadReport(startServicePublisherLibraryOrdersDeliveredPdfObj);
            }
        }
        else {
            store.commit("setPublisherLibraryOrdersDeliveredPdf", storeObj);
            clearInterval(publisherLibraryOrdersDeliveredPdf);
            publisherLibraryOrdersDeliveredPdf = null;
        }
    },

    startServicePublisherLibraryOrdersDeliveredXlsx(dates, institution) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(institution === -1){
            institution = null;
        }
        if(publisherLibraryOrdersDeliveredXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit("setPublisherLibraryOrdersDeliveredXlsx", storeObj);
        publisherLibraryOrdersDeliveredXlsx = setInterval( () => {
            var obj = {
                type: "publisherLibraryOrdersDelivered",
                requesterId: null,
                format: "xlsx",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: institution,
                distributionPointId: null
            };
            startServicePublisherLibraryOrdersDeliveredXlsxObj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherLibraryOrdersDeliveredXlsxCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        }, 5000)
    },

    startServicePublisherLibraryOrdersDeliveredXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherLibraryOrdersDeliveredXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherLibraryOrdersDeliveredXlsx", storeObj);
                clearInterval(publisherLibraryOrdersDeliveredXlsx);
                publisherLibraryOrdersDeliveredXlsx = null;
                utils.downloadReport(startServicePublisherLibraryOrdersDeliveredXlsxObj);
            }
        }
        else {
            store.commit("setPublisherLibraryOrdersDeliveredXlsx", storeObj);
            clearInterval(publisherLibraryOrdersDeliveredXlsx);
            publisherLibraryOrdersDeliveredXlsx = null;
        }
    },

    startServicePublisherBooksFromCourierDeliveredXlsx(dates) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(publisherBooksFromCourierDeliveredXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit('setPublisherBooksFromCourierDeliveredXlsx', storeObj);
        publisherBooksFromCourierDeliveredXlsx = setInterval(() => {
            var obj = {
                type: "publisherBooksFromCourierDelivered",
                requesterId: null,
                format: "xlsx",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: null,
                distributionPointId: null
            };
            startServicePublisherBooksFromCourierDeliveredXlsxobj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherBooksFromCourierDeliveredXlsxCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        },5000)
    },

    startServicePublisherBooksFromCourierDeliveredXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherBooksFromCourierDeliveredXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherBooksFromCourierDeliveredXlsx", storeObj);
                clearInterval(publisherBooksFromCourierDeliveredXlsx);
                publisherBooksFromCourierDeliveredXlsx = null;
                utils.downloadReport(startServicePublisherBooksFromCourierDeliveredXlsxobj);
            }
        }
        else {
            store.commit("setPublisherBooksFromCourierDeliveredXlsx", storeObj);
            clearInterval(publisherBooksFromCourierDeliveredXlsx);
            publisherBooksFromCourierDeliveredXlsx = null;
        }
    },

    startServicePublisherBooksFromCourierDeliveredPdf(dates) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(publisherBooksFromCourierDeliveredXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit('setPublisherBooksFromCourierDeliveredPdf', storeObj);
        publisherBooksFromCourierDeliveredPdf = setInterval(() => {
            var obj = {
                type: "publisherBooksFromCourierDelivered",
                requesterId: null,
                format: "pdf",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: null,
                distributionPointId: null
            };
            startServicePublisherBooksFromCourierDeliveredPdfobj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherBooksFromCourierDeliveredPdfCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        },5000)
    },

    startServicePublisherBooksFromCourierDeliveredPdfCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherBooksFromCourierDeliveredPdf));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherBooksFromCourierDeliveredPdf", storeObj);
                clearInterval(publisherBooksFromCourierDeliveredPdf);
                publisherBooksFromCourierDeliveredPdf = null;
                utils.downloadReport(startServicePublisherBooksFromCourierDeliveredPdfobj);
            }
        }
        else {
            store.commit("setPublisherBooksFromCourierDeliveredPdf", storeObj);
            clearInterval(publisherBooksFromCourierDeliveredPdf);
            publisherBooksFromCourierDeliveredPdf = null;
        }
    },


    startServicePublisherSelectedBooksXlsx(year) {
        if(publisherSelectedBooksXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
            store.commit("setPublisherSelectedBooksXlsx", storeObj);
            publisherSelectedBooksXlsx = setInterval( () => {
                var obj = {
                    type: "publisherSelectedBooks",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: year,
                    period: null,
                    fromDate: null,
                    toDate: null,
                    institutionId: null,
                    distributionPointId: null,
                };
                startServicePublisherSelectedBooksXlsxobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServicePublisherSelectedBooksXlsxCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 5000)
        }
    },

    startServicePublisherSelectedBooksXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherSelectedBooksXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if(response.data == "CREATED"){
                store.commit("setPublisherSelectedBooksXlsx", storeObj);
                clearInterval(publisherSelectedBooksXlsx);
                publisherSelectedBooksXlsx = null;
                utils.downloadReport(startServicePublisherSelectedBooksXlsxobj);
            }
        }
        else {
            store.commit("setPublisherSelectedBooksXlsx", storeObj);
            clearInterval(publisherSelectedBooksXlsx);
            publisherSelectedBooksXlsx = null;
        }
    },

    startServicePublisherBooksXls() {
        if(publisherBooksXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
        }
        store.commit("setPublisherBooksXlsx" ,storeObj);
        publisherBooksXlsx = setInterval( () => {
            var obj = {
                type: "publisherBooks",
                requesterId: null,
                format: "xlsx",
                academicYear: null,
                period: null,
                fromDate: null,
                toDate: null,
                institutionId: null,
                distributionPointId: null,
            };
            startServicePublisherBooksXlsxobj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServicePublisherBooksXlsxCallBack);
            } else {
                store.commit('setloginModal', true);
            }

        }, 5000)
    },

    startServicePublisherBooksXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.publisherBooksXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setPublisherBooksXlsx", storeObj);
                clearInterval(publisherBooksXlsx);
                publisherBooksXlsx = null;
                utils.downloadReport(startServicePublisherBooksXlsxobj);
            }
        }
        else {
            store.commit("setPublisherBooksXlsx", storeObj);
            clearInterval(publisherBooksXlsx);
            publisherBooksXlsx = null;
        }
    },

    startServiceAmountOfBooksDeliveredPerDpPdf(dates ,distPointId) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(amountOfBooksDeliveredPerDpPdf == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
        }
        store.commit('setAmountOfBooksDeliveredPerDpPdf', storeObj);
        amountOfBooksDeliveredPerDpPdf = setInterval(() => {
            var obj = {
                type: "publisherDeliveredBooksPerDP",
                requesterId: null,
                format: "pdf",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: null,
                distributionPointId: distPointId.id
            };
            startServiceAmountOfBooksDeliveredPerDpPdfobj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServiceAmountOfBooksDeliveredPerDpPdfCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        },5000)
    },

    startServiceAmountOfBooksDeliveredPerDpPdfCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.amountOfBooksDeliveredPerDpPdf));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setAmountOfBooksDeliveredPerDpPdf", storeObj);
                clearInterval(amountOfBooksDeliveredPerDpPdf);
                amountOfBooksDeliveredPerDpPdf = null;
                utils.downloadReport(startServiceAmountOfBooksDeliveredPerDpPdfobj);
            }
        }
        else {
            store.commit("setAmountOfBooksDeliveredPerDpPdf", storeObj);
            clearInterval(amountOfBooksDeliveredPerDpPdf);
            amountOfBooksDeliveredPerDpPdf = null;
        }
    },

    startServiceAmountOfBooksDeliveredPerDpXlsx(dates ,distPointId) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(amountOfBooksDeliveredPerDpXlsx == null) {
            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
        }
        store.commit('setAmountOfBooksDeliveredPerDpXlsx', storeObj);
        amountOfBooksDeliveredPerDpXlsx = setInterval(() => {
            var obj = {
                type: "publisherDeliveredBooksPerDP",
                requesterId: null,
                format: "xlsx",
                academicYear: null,
                period: null,
                fromDate: dateFrom,
                toDate: dateTo,
                institutionId: null,
                distributionPointId: distPointId.id
            };
            startServiceAmountOfBooksDeliveredPerDpXlsxobj = obj;
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.reports(token, obj, this.startServiceAmountOfBooksDeliveredPerDpXlsxCallBack);
            } else {
                store.commit('setloginModal', true);
            }
        },5000)
    },

    startServiceAmountOfBooksDeliveredPerDpXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.amountOfBooksDeliveredPerDpXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setAmountOfBooksDeliveredPerDpXlsx", storeObj);
                clearInterval(amountOfBooksDeliveredPerDpXlsx);
                amountOfBooksDeliveredPerDpXlsx = null;
                utils.downloadReport(startServiceAmountOfBooksDeliveredPerDpXlsxobj);
            }
        }
        else {
            store.commit("setAmountOfBooksDeliveredPerDpXlsx", storeObj);
            clearInterval(amountOfBooksDeliveredPerDpXlsx);
            amountOfBooksDeliveredPerDpXlsx = null;
        }
    },

    startServiceAmountOfBooksDeliveredForAllDpXlsx(dates) {
        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if(amountOfBooksDeliveredForAllDpXlsx == null){
            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
            store.commit('setAmountOfBooksDeliveredForAllDpXlsx', storeObj);
            amountOfBooksDeliveredForAllDpXlsx = setInterval(() => {
                var obj = {
                    type: "publisherDeliveredBooksPerDP",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: null,
                    period: null,
                    fromDate: dateFrom,
                    toDate: dateTo,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceAmountOfBooksDeliveredForAllDpXlsxobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceAmountOfBooksDeliveredForAllDpXlsxCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            },5000)
        }
    },

    startServiceAmountOfBooksDeliveredForAllDpXlsxCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.amountOfBooksDeliveredForAllDpXlsx));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED'){
                store.commit("setAmountOfBooksDeliveredForAllDpXlsx", storeObj);
                clearInterval(amountOfBooksDeliveredForAllDpXlsx);
                amountOfBooksDeliveredForAllDpXlsx = null;
                utils.downloadReport(startServiceAmountOfBooksDeliveredForAllDpXlsxobj);
            }
        }
        else {
            store.commit("setAmountOfBooksDeliveredForAllDpXlsx", storeObj);
            clearInterval(amountOfBooksDeliveredForAllDpXlsx);
            amountOfBooksDeliveredForAllDpXlsx = null;
        }
    },

    startServiceAmountOfBooksDeliveredForAllDpPdf(dates) {

        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);

        if (amountOfBooksDeliveredForAllDpPdf == null){

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
            store.commit('setAmountOfBooksDeliveredForAllDpPdf', storeObj);
            amountOfBooksDeliveredForAllDpPdf = setInterval(() => {
                var obj = {
                    type: "publisherDeliveredBooksPerDP",
                    requesterId: null,
                    format: "pdf",
                    academicYear: null,
                    period: null,
                    fromDate: dateFrom,
                    toDate: dateTo,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceAmountOfBooksDeliveredForAllDpPdfobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceAmountOfBooksDeliveredForAllDpPdfCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 5000)
        }
    },

    startServiceAmountOfBooksDeliveredForAllDpPdfCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.amountOfBooksDeliveredForAllDpPdf));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if(response.data == "CREATED"){
                store.commit("setAmountOfBooksDeliveredForAllDpPdf", storeObj);
                clearInterval(amountOfBooksDeliveredForAllDpPdf);
                amountOfBooksDeliveredForAllDpPdf = null;
                utils.downloadReport(startServiceAmountOfBooksDeliveredForAllDpPdfobj);
            }
        }
        else {
            store.commit("setAmountOfBooksDeliveredForAllDpPdf", storeObj);
            clearInterval(amountOfBooksDeliveredForAllDpPdf);
            amountOfBooksDeliveredForAllDpPdf = null;
        }
    },

    startServiceAmountOfPDF(dates) {

        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);


        if (amountOfSelectedBooksPDF == null) {

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
            store.commit('setAmountOfSelectedBooksPDF', storeObj);
            amountOfSelectedBooksPDF = setInterval(() => {

                var obj = {
                    type: "publisherStudentBookSelections",
                    requesterId: null,
                    format: "pdf",
                    academicYear: null,
                    period: null,
                    fromDate: dateFrom,
                    toDate: dateTo,
                    institutionId: null,
                    distributionPointId: null
                };

                startServiceAmountOfPDFobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceAmountOfPDFCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 10000);
        }
    },

    startServiceAmountOfPDFCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.amountOfSelectedBooksPDF));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setAmountOfSelectedBooksPDF', storeObj);
                clearInterval(amountOfSelectedBooksPDF);
                amountOfSelectedBooksPDF = null;
                utils.downloadReport(startServiceAmountOfPDFobj);
            }
        }
        else {
            store.commit('setAmountOfSelectedBooksPDF', storeObj);
            clearInterval(amountOfSelectedBooksPDF);
            amountOfSelectedBooksPDF = null;
        }
    },

    startServiceAmountOfXLSX(dates) {

        if (amountOfSelectedBooksXLSX == null) {

            var dateFrom = utils.returnDateFrom(dates);
            var dateTo = utils.returnDateTo(dates);

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
            store.commit('setAmountOfSelectedBooksXLSX', storeObj);
            amountOfSelectedBooksXLSX = setInterval(() => {

                var obj = {
                    type: "publisherStudentBookSelections",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: null,
                    period: null,
                    fromDate: dateFrom,
                    toDate: dateTo,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceAmountOfXLSXobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceAmountOfXLSXCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 10000);
        }
    },

    startServiceAmountOfXLSXCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.amountOfSelectedBooksXLSX));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setAmountOfSelectedBooksXLSX', storeObj);
                clearInterval(amountOfSelectedBooksXLSX);
                amountOfSelectedBooksXLSX = null;
                utils.downloadReport(startServiceAmountOfXLSXobj);
            }
        }
        else {
            store.commit('setAmountOfSelectedBooksXLSX', storeObj);
            clearInterval(amountOfSelectedBooksXLSX);
            amountOfSelectedBooksXLSX = null;
        }
    },

    startServiceDeliveredBooksPDF(dates) {

        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);


        if (deliveredBooksPDF == null) {

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
            store.commit('setDeliveredBooksPDF', storeObj);
            deliveredBooksPDF = setInterval(() => {

                var obj = {
                    type: "publisherDeliveredBooksPerCourse",
                    requesterId: null,
                    format: "pdf",
                    academicYear: null,
                    period: null,
                    fromDate: dateFrom,
                    toDate: dateTo,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceDeliveredBooksPDFobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceDeliveredBooksPDFCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 5000);
        }
    },

    startServiceDeliveredBooksPDFCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.deliveredBooksPDF));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setDeliveredBooksPDF', storeObj);
                clearInterval(deliveredBooksPDF);
                deliveredBooksPDF = null;
                utils.downloadReport(startServiceDeliveredBooksPDFobj);
            }
        }
        else {
            store.commit('setDeliveredBooksPDF', storeObj);
            clearInterval(deliveredBooksPDF);
            deliveredBooksPDF = null;
        }
    },

    startServiceDeliveredBooksXLSX(dates) {

        var dateFrom = utils.returnDateFrom(dates);
        var dateTo = utils.returnDateTo(dates);


        if (deliveredBooksXLSX == null) {

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: dateFrom,
                toDate: dateTo,
            };
            store.commit('setDeliveredBooksXLSX', storeObj);
            deliveredBooksXLSX = setInterval(() => {

                var obj = {
                    type: "publisherDeliveredBooksPerCourse",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: null,
                    period: null,
                    fromDate: dateFrom,
                    toDate: dateTo,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceDeliveredBooksXLSXobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceDeliveredBooksXLSXCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 5000);
        }
    },

    startServiceDeliveredBooksXLSXCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.deliveredBooksXLSX));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setDeliveredBooksXLSX', storeObj);
                clearInterval(deliveredBooksXLSX);
                deliveredBooksXLSX = null;
                utils.downloadReport(startServiceDeliveredBooksXLSXobj);
            }
        }
        else {
            store.commit('setDeliveredBooksXLSX', storeObj);
            clearInterval(deliveredBooksXLSX);
            deliveredBooksXLSX = null;
        }
    },

    startServiceBooksDistributionXLSX() {


        if (booksDistributionXLSX == null) {

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: null,
                toDate: null,
            };
            store.commit('setDooksDistributionXLSX', storeObj);
            booksDistributionXLSX = setInterval(() => {

                var obj = {
                    type: "publisherSelectedBooksAvailability",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: null,
                    period: null,
                    fromDate: null,
                    toDate: null,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceBooksDistributionXLSXobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceBooksDistributionXLSXCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 5000);
        }
    },

    startServiceBooksDistributionXLSXCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.booksDistributionXLSX));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setDooksDistributionXLSX', storeObj);
                clearInterval(booksDistributionXLSX);
                booksDistributionXLSX = null;
                utils.downloadReport(startServiceBooksDistributionXLSXobj);
            }
        }
        else {
            store.commit('setDooksDistributionXLSX', storeObj);
            clearInterval(booksDistributionXLSX);
            booksDistributionXLSX = null;
        }
    },

    startServiceHomeDeliveryXLSX(fromDate, toDate) {


        if (homeDeliveryXLSX == null) {

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: fromDate,
                toDate: toDate,
            };
            store.commit('setHomeDeliveryXLSX', storeObj);
            homeDeliveryXLSX = setInterval(() => {

                var obj = {
                    type: "studentSelectedBooksForHomeDelivery",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: null,
                    period: null,
                    fromDate: fromDate,
                    toDate: toDate,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceHomeDeliveryXLSXobj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceHomeDeliveryXLSXCallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 15000);
        }
    },

    startServiceHomeDeliveryXLSXCallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.homeDeliveryXLSX));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setHomeDeliveryXLSX', storeObj);
                clearInterval(homeDeliveryXLSX);
                homeDeliveryXLSX = null;
                utils.downloadReport(startServiceHomeDeliveryXLSXobj);
            }
        }
        else {
            store.commit('setHomeDeliveryXLSX', storeObj);
            clearInterval(homeDeliveryXLSX);
            homeDeliveryXLSX = null;
        }
    },

    startServiceHomeDeliveryXLSX1(fromDate, toDate) {


        if (homeDeliveryXLSX1 == null) {

            var storeObj = {
                isLoading: true,
                isReady: false,
                fromDate: fromDate,
                toDate: toDate,
            };
            store.commit('setHomeDeliveryXLSX1', storeObj);
            homeDeliveryXLSX1 = setInterval(() => {

                var obj = {
                    type: "studentSelectedBooksForHomeDelivery",
                    requesterId: null,
                    format: "xlsx",
                    academicYear: null,
                    period: null,
                    fromDate: fromDate,
                    toDate: toDate,
                    institutionId: null,
                    distributionPointId: null
                };
                startServiceHomeDeliveryXLSX1obj = obj;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    request.reports(token, obj, this.startServiceHomeDeliveryXLSX1CallBack);
                } else {
                    store.commit('setloginModal', true);
                }
            }, 15000);
        }
    },

    startServiceHomeDeliveryXLSX1CallBack(response) {

        var storeObj = JSON.parse(JSON.stringify(store.getters.homeDeliveryXLSX));
        storeObj.isLoading = false;
        storeObj.isReady = true;
        if (response.status == 200) {
            if (response.data == 'CREATED') {
                store.commit('setHomeDeliveryXLSX1', storeObj);
                clearInterval(homeDeliveryXLSX1);
                homeDeliveryXLSX1 = null;
                utils.downloadReport(startServiceHomeDeliveryXLSX1obj);
            }
        }
        else {
            store.commit('setHomeDeliveryXLSX1', storeObj);
            clearInterval(homeDeliveryXLSX1);
            homeDeliveryXLSX1 = null;
        }
    },

    startStatementReport(fromDate, toDate) {
        var obj = {
            type: "publisherStatementAndDeliveryStatsReport",
            requesterId: null,
            format: "xlsx",
            academicYear: null,
            period: null,
            fromDate: fromDate,
            toDate: toDate,
            institutionId: null,
            distributionPointId: null
        };

        publisherStatementAndDeliveryStatsReportRequestObj = obj;

        // Check status first (without setting loading state yet)
        var token = utils.getLocalStorage('token');
        if (token != null) {
            request.checkReportStatus(token, obj, this.checkStatementReportStatus.bind(this));
        } else {
            store.commit('setloginModal', true);
        }
    },

    checkStatementReportStatus(response) {
        // Only set loading state if the initial status check succeeds
        if (response.status == 200) {
            var storeObj = {
                isLoading: true,
                isReady: false,
            };
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
        }

        if (response.status == 200 && response.data == 'MISSING') {
            // Report doesn't exist, create it
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.createReport(token, publisherStatementAndDeliveryStatsReportRequestObj, this.createStatementReport.bind(this));
            }
        } else if (response.status == 200 && response.data == 'CREATED') {
            // Report is ready, download it immediately
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.getReportFile(token, publisherStatementAndDeliveryStatsReportRequestObj, this.downloadStatementReport.bind(this));
            }
        } else if (response.status == 200 && response.data == 'PENDING') {
            // Report is pending, start polling
            if (publisherStatementAndDeliveryStatsReportPolling == null) {
                publisherStatementAndDeliveryStatsReportPolling = setInterval(() => {
                    var token = utils.getLocalStorage('token');
                    if (token != null) {
                        request.checkReportStatus(token, publisherStatementAndDeliveryStatsReportRequestObj, this.statementReportStatusCallback.bind(this));
                    }
                }, 15000); // Poll every 15 seconds
            }
        } else if (response.status != 200) {
            // Error on status check - reset loading state
            var storeObj = {
                isLoading: false,
                isReady: false,
            };
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
        }
    },

    createStatementReport(response) {
        if (response.status == 200) {
            // Report created, start polling
            if (publisherStatementAndDeliveryStatsReportPolling == null) {
                publisherStatementAndDeliveryStatsReportPolling = setInterval(() => {
                    var token = utils.getLocalStorage('token');
                    if (token != null) {
                        request.checkReportStatus(token, publisherStatementAndDeliveryStatsReportRequestObj, this.statementReportStatusCallback.bind(this));
                    }
                }, 15000); // Poll every 15 seconds
            }
        } else {
            // Error on create - reset loading state
            var storeObj = {
                isLoading: false,
                isReady: false,
            };
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
        }
    },

    statementReportStatusCallback(response) {
        if (response.status == 200 && response.data == 'CREATED') {
            // Report is ready, download it
            var storeObj = JSON.parse(JSON.stringify(store.getters.publisherStatementAndDeliveryStatsReport));
            storeObj.isLoading = false;
            storeObj.isReady = true;
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
            clearInterval(publisherStatementAndDeliveryStatsReportPolling);
            publisherStatementAndDeliveryStatsReportPolling = null;
            
            // Download the report
            var token = utils.getLocalStorage('token');
            if (token != null) {
                request.getReportFile(token, publisherStatementAndDeliveryStatsReportRequestObj, this.downloadStatementReport.bind(this));
            }
        } else if (response.status == 200 && response.data == 'PENDING') {
            // Still pending, keep polling (do nothing, interval will continue)
        } else {
            // Error or unexpected status - stop polling and reset loading state
            var storeObj = JSON.parse(JSON.stringify(store.getters.publisherStatementAndDeliveryStatsReport));
            storeObj.isLoading = false;
            storeObj.isReady = false;
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
            clearInterval(publisherStatementAndDeliveryStatsReportPolling);
            publisherStatementAndDeliveryStatsReportPolling = null;
        }
    },

    downloadStatementReport(response) {
        // Check if response is successful (status 200 means file download)
        if (response && response.status == 200) {
            // Download the file
            utils.downLoadXLSX(response);
            
            // Reset loading state after successful download
            var storeObj = {
                isLoading: false,
                isReady: true,
            };
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
        } else {
            // Error downloading file - reset loading state
            var storeObj = {
                isLoading: false,
                isReady: false,
            };
            store.commit('setPublisherStatementAndDeliveryStatsReport', storeObj);
        }
    },
};

export default Serv;